import { NavLink, Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const navCls = ({ isActive }) =>
  `text-[10px] sm:text-xs tracking-[0.15em] sm:tracking-[0.2em] uppercase pb-1 border-b transition-colors duration-200 ${isActive ? "border-[var(--ink)] text-[var(--ink)]" : "border-transparent text-[var(--muted-ink)] hover:text-[var(--ink)]"}`;

export const AppShell = ({ children }) => {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen grain">
      <header className="sticky top-0 z-40 bg-[var(--cream)]/85 backdrop-blur-md border-b border-[var(--line)]">
        <div className="max-w-[1400px] mx-auto px-4 md:px-10 h-16 flex items-center justify-between gap-3">
          <Link to="/" className="flex items-baseline gap-4 shrink-0" data-testid="nav-home-link">
            <span className="wordmark text-sm sm:text-lg">JORDYBLUE</span>
            <span className="hidden sm:inline text-[11px] tracking-[0.25em] uppercase text-[var(--muted-ink)]">Catalog Studio</span>
          </Link>
          <nav className="flex items-center gap-4 md:gap-8">
            <NavLink to="/" end className={navCls} data-testid="nav-catalogs-link">Catalogs</NavLink>
            <NavLink to="/settings" className={navCls} data-testid="nav-settings-link">Settings</NavLink>
            <NavLink to="/logs" className={navCls} data-testid="nav-logs-link">Logs</NavLink>
            <button onClick={logout} className="text-[var(--muted-ink)] hover:text-[var(--ink)] transition-colors" data-testid="logout-button" title="Log out">
              <LogOut size={16} />
            </button>
          </nav>
        </div>
      </header>
      <main className="max-w-[1400px] mx-auto px-6 md:px-10 py-10 md:py-14">{children}</main>
    </div>
  );
};
